const breakpoints = {
  values: {
    xs: 0,
    sm: 672,
    md: 960,
    lg: 1280,
    xl: 1440,
  },
};

export default breakpoints;
